import {
    GET_CARS,
    UPDATE_INPUT_CAR,
    SUBMIT_UPDATED_CAR,
    DELETE_CAR,
} from './types';
import {
    getCarsFromFirebase,
    updateCarToFirebase,
    deleteCarFromFirebase,
} from '../helpers/firebase';

export async function getCars() {
    const data = await getCarsFromFirebase();

    let arr = [];
    if(data)
        arr = Object.keys(data).map(key => {
            let item = data[key];
            item['key'] = key;

            return item;
        });

    return {
        type: GET_CARS,
        payload: arr,
    };
}

export function updateInputCar(car) {
    return {
        type: UPDATE_INPUT_CAR,
        payload: car,
    };
}

export function submitUpdatedCar(car) {
    updateCarToFirebase(car);

    return {
        type: SUBMIT_UPDATED_CAR,
        payload: {},
    };
}

export function deleteCar(key) {
    deleteCarFromFirebase(key);

    return {
        type: DELETE_CAR,
        payload: key,
    }
}


// WEBPACK FOOTER //
// ./src/app/actions/cars_actions.js